// One Learn click: every section in a single background job (COM-586). Returns
// one result per section, in order, shaped like a /v1/template/learn response
// plus its `key`. A section the backend failed on (non-2xx, e.g. a timeout or
// no edit access) comes back with `failed: true`, so callers can still apply
// the sections that learned. Throws only when the whole request fails.
export async function learnTemplateSections(
  apiClient,
  conversationId,
  configId,
  sections,
  eventId = crypto.randomUUID(),
) {
  const response = await apiClient.learnSections(
    conversationId,
    configId,
    sections.map(({ key, usersEdits }) => ({ section: key, usersEdits })),
    eventId,
  );
  if (!response || !response.sections) {
    throw new Error(response?.error || 'Learn returned no results');
  }
  return sections.map(({ key }) => {
    const outcome = response.sections[key];
    if (!outcome) return { key, failed: true };
    if (outcome.status >= 300) return { ...outcome.body, key, failed: true };
    return { ...outcome.body, key };
  });
}

// The banner to show once a Learn click's results are applied.
export function learnResultBanner(results, learnedChanges) {
  const failed = results.filter((result) => result.failed).map((r) => r.key);
  if (failed.length === 0) {
    return learnedChanges ? 'Edits Learned ✅' : 'No edits detected';
  }
  const failedList = failed.join(', ');
  return learnedChanges
    ? `Edits Learned ✅ (couldn't learn ${failedList})`
    : `Couldn't learn ${failedList}`;
}
